import { Outlet } from "react-router-dom";

const OrdersData = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default OrdersData;
